import { render, staticRenderFns } from "./innerPage02.vue?vue&type=template&id=2670e8ca&scoped=true&"
import script from "./innerPage02.vue?vue&type=script&lang=js&"
export * from "./innerPage02.vue?vue&type=script&lang=js&"
import style0 from "./innerPage02.vue?vue&type=style&index=0&id=2670e8ca&prod&lang=less&"
import style1 from "./innerPage02.vue?vue&type=style&index=1&id=2670e8ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2670e8ca",
  null
  
)

export default component.exports